/**
 * If Latest is selected and using TopID then Relevance default.
 */
export const SORT = {
	Relevance: 'RELEVANCE',
	Latest: 'NEW_ARRIVAL_DESC',
	Oldest: 'NEW_ARRIVAL_ASC',
	BestSellers: 'RATING_DESC',
	LowestPrice: 'PRICE_ASC',
	HighestPrice: 'PRICE_DESC',
}

export const DEFAULT_PER_PAGE_LIMIT = 36;

export const DEFAULT_SORT = 'RELEVANCE';

export const PAGE_SIZES = [36, 72, 108];

export const LIMIT_PAGE_SIZE = 100;



// WEBPACK FOOTER //
// ./klevu/constants.js